<template>
  <div v-if="controls.length > 0" class="controls">
    <div v-for="(control, index) in controls" :key="index" :class="['control', control.level]">
      <div class="control-header" :class="{expandable: hasDetails(control)}" @click="toggle(index)">
        <span :class="control.level === 'warning' ? 'fas fa-triangle-exclamation' : 'fas fa-circle-info'"></span>
        <span class="control-message">{{ control.message }}</span>
        <span v-if="hasDetails(control)" class="fas control-chevron" :class="openControls[index] ? 'fa-chevron-up' : 'fa-chevron-down'" title="Afficher le détail"></span>
      </div>
      <div v-if="openControls[index]" class="control-details">
        <p v-if="control.action" class="control-action"><strong>À faire :</strong> {{ control.action }}</p>
        <table v-if="control.rows && control.rows.length > 0" class="control-table">
          <thead>
          <tr>
            <th v-for="column in control.columns" :key="column" :class="{right: column === 'amount'}">{{ columnLabel(column) }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, rowIndex) in control.rows" :key="rowIndex">
            <td v-for="column in control.columns" :key="column" :class="{right: column === 'amount'}">{{ cellValue(row, column) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {controlCellValue, controlColumnLabel} from "@/accounting/services/export/AccountingFormat";

/**
 * Contrôles de l'export comptable : avertissements et informations, chacun dépliable pour lister les objets à traiter.
 */
export default {
  name: 'AccountingControls',
  props: ['controls'],
  data() {
    return {
      openControls: {},
    };
  },
  watch: {
    controls() {
      this.openControls = {};
    },
  },
  methods: {
    columnLabel: controlColumnLabel,
    cellValue: controlCellValue,
    hasDetails(control) {
      return !!control.action || (control.rows && control.rows.length > 0);
    },
    toggle(index) {
      this.openControls = {...this.openControls, [index]: !this.openControls[index]};
    },
  },
};
</script>

<style lang="stylus" scoped>
.controls
  display flex
  flex-direction column
  gap 4px

.control
  padding 6px 12px
  border-radius 6px
  font-size 13px
  background #eef3f6

  &.warning
    background #fff3cd

.control-header
  display flex
  align-items center
  gap 8px

  &.expandable
    cursor pointer

.control-message
  flex 1

.control-chevron
  font-size 11px

.control-details
  margin-top 6px
  padding-top 6px
  border-top 1px solid rgba(0, 0, 0, .08)

.control-action
  margin 0 0 6px

.control-table
  border-collapse collapse
  background rgba(255, 255, 255, .6)

  th, td
    padding 3px 12px 3px 8px
    text-align left
    white-space nowrap

  th
    font-size 12px
    color #526570

  .right
    text-align right
</style>
